<template>
  <div class="detail_box">
    <van-nav-bar
      title="Detalhes"
      left-text=""
      left-arrow
      :fixed="true"
      @click-left="$router.go(-1)"
    />
    <div class="data_box">
      <div
        v-for="(item, index) in dataList"
        :key="item.key"
        class="item flex-1 flex-row align-center justify-between"
      >
        <div>{{ item.title }}</div>
        <div :class="[[0, 3].includes(index) ? 'color' : '', index === 0 ? 'f-w-b' : '']">
          {{ detail[item.key] || item.key }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { NavBar } from "vant";
Vue.use(NavBar);
import Fetch from "../../utils/fetch";
export default {
    components: {
    },
    data() {
        return {
            dataList: [
                {
                    title: this.$t("账户变更类别"),
                    key: 'memo',
                },
                {
                    title: this.$t('时间'),
                    key: 'createtime'
                },
                {
                    title: this.$t("钱包类型"),
                    key: 'Carteira de saldo'
                },
                {
                    title: this.$t("数量"),
                    key: 'money'
                },
                {
                    title: this.$t("变更前的平衡"),
                    key: 'before'
                },
                {
                    title: this.$t("变动后余额"),
                    key: 'after'
                },
            ],
            detail: {
            }
        }
    },
    created() {
        this.getDetail()
    },
    methods: {
        getDetail() {
            Fetch("/record/moneyDetail", { id: this.$route.query.id }, {
                method: 'get'
            }).then((r) => {
                if (r.data) {
                    this.detail = r.data.detail
                }
            });
        }
    }
}
</script>
<style scoped lang="less">
@import "../../assets/css/variables.less";
@import "./modules/comment.less";


/deep/ .van-nav-bar {
    background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
    color: #fff;
}

/deep/ .van-nav-bar__title {
    color: #fff;
}

.detail_box {
    height: 100vh;
    background-color: @activityColor;
    padding-top: 45px;
    box-sizing: border-box;
    font-size: 12px;

    .data_box {
        margin: 10px;
        padding: 10px;
        box-sizing: border-box;
        background-color: @secondary-color;
        border-radius: 8px;
        color: @textcolor5;
        box-shadow: 0 .03rem .09rem rgba(255, 255, 255, .1);

        .item {
            padding: 5px 0;
            width: 100%;

            div {
                width: 50%;

                &:last-child {
                    text-align: right;
                }
            }

            .color {
                color: @textcolor3;

            }
        }
    }
}
</style>